import React, { useEffect, useState } from 'react';
import './exchange.scss';

const tokenImages = {
  BNB: '/assets/one.svg',
  OKX: '/assets/two.svg',
  MX: '/assets/four.svg',
  BGB: '/assets/five.svg',
  KCS: '/assets/six.svg',
  HTX: '/assets/seven.svg',
  CRO: '/assets/nine.svg',
  CHZ: '/assets/ten.svg',
  HYPE: '/assets/eleven.svg',
  ASTER: '/assets/aster.svg',
  UNI: '/assets/twe.svg',
  PUMP: '/assets/thirten.svg',
  GEMS: '/assets/fourten.svg',
  RAIN: '/assets/fiften.svg',
};

const initialAllocations = {
  BNB: { id: 'binancecoin', allocation: 20000000, price: 806.73 },
  OKX: { id: 'okb', allocation: 5700000, price: 46.10 },
  MX: { id: 'mx-token', allocation: 2850000, price: 2.32 },
  BGB: { id: 'bitget-token', allocation: 2850000, price: 4.40 },
  KCS: { id: 'kucoin-shares', allocation: 2850000, price: 11.77 },
  HTX: { id: 'htx-dao', allocation: 2850000, price: 0.00000200 },

  CRO: { id: 'crypto-com-chain', allocation: 6000000, price: 0.1656 },
  CHZ: { id: 'chiliz', allocation: 6000000, price: 0.0410 },
  HYPE: { id: 'hyperliquid', allocation: 6000000, price: 43.20 },
  ASTER: { id: 'aster-2', allocation: 6000000, price: 1.37 },
  UNI: { id: 'uniswap', allocation: 2850000, price: 11.15 },
  PUMP: { id: 'pump-fun', allocation: 6000000, price: 0.00311 },

  GEMS: { id: 'gems-vip', allocation: 15000000, price: 0.1174 },
  RAIN: { id: null, allocation: 15000000 }, // no live price
};

const API_KEY = 'CG-AMT6oz8K7Qpx7qESamW9hKZu';

const Exchange = ({ totalMarketCap, setTotalMarketCap }) => {
  const [marketData, setMarketData] = useState({});

  const fetchLivePrices = async () => {
    const ids = Object.values(initialAllocations)
      .map((t) => t.id)
      .filter(Boolean)
      .join(',');

    const res = await fetch(
      `https://pro-api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=${ids}`,
      { headers: { 'x-cg-pro-api-key': API_KEY } }
    );

    const data = await res.json();
    let updatedData = {};
    let total = 0;

    Object.entries(initialAllocations).forEach(([symbol, { id, allocation, price }]) => {
      if (!id) {
        updatedData[symbol] = { currentValue: allocation, livePrice: null };
        total += allocation;
        return;
      }
      const live = data.find((d) => d.id === id);
      if (!live) return;

      const livePrice = live.current_price;
      const tokenAmount = allocation / price; // how many tokens bought
      const currentValue = tokenAmount * livePrice;

      updatedData[symbol] = { currentValue, livePrice };
      total += currentValue;
    });

    setMarketData(updatedData);
    setTotalMarketCap(total);
  };

  useEffect(() => {
    fetchLivePrices();
    const interval = setInterval(fetchLivePrices, 10000);
    return () => clearInterval(interval);
  }, []);

  const formatMillion = (num) => {
    return `$${(num / 1_000_000).toFixed(2)}M`;
  };

  const renderCard = (symbol) => (
    <div className='cardss' key={symbol}>
      <h3>{symbol}</h3>
      <h4>
        {marketData[symbol]
          ? formatMillion(marketData[symbol].currentValue)
          : 'Loading...'}
      </h4>
      <img src={tokenImages[symbol]} className='bottom' alt={symbol} />
    </div>
  );


  return (
    <section className='Exchange_main'>
      <div className='Exchange_new'>
        <div className='custom-container'>
          <div className='top_chart'>
            {/* <h2 className='mb-4'>Total Market Cap: {formatMillion(totalMarketCap)}</h2> */}

            <ul className='nav nav-pills mb-3' id='pills-tab' role='tablist'>
              <li className='nav-item' role='presentation'>
                <button className='nav-link active' id='pills-home-tab' data-bs-toggle='pill' data-bs-target='#pills-home' type='button' role='tab' aria-controls='pills-home' aria-selected='true'>Backbone</button>
              </li>
              <li className='nav-item' role='presentation'>
                <button className='nav-link' id='pills-profile-tab' data-bs-toggle='pill' data-bs-target='#pills-profile' type='button' role='tab' aria-controls='pills-profile' aria-selected='false'>Growth Engines</button>
              </li>
              <li className='nav-item' role='presentation'>
                <button className='nav-link' id='pills-contact-tab' data-bs-toggle='pill' data-bs-target='#pills-contact' type='button' role='tab' aria-controls='pills-contact' aria-selected='false'>Moonshots</button>
              </li>
            </ul>

            <div className='tab-content' id='pills-tabContent'>
              {/* Backbone */}
              <div className='tab-pane fade show active' id='pills-home' role='tabpanel' aria-labelledby='pills-home-tab'>
                <div className='ouuuter_Side'>
                  <div className='ouuter__new'>
                    <h2>Backbone – 40% ($40M)</h2>
                    <div className='side_div'>
                      {['BNB', 'OKX', 'MX', 'BGB', 'KCS', 'HTX', 'UNI'].map(renderCard)}
                    </div>
                  </div>
                  <div>
                    <h2>Exchange Token Basket Allocation</h2>
                    <img src='\assets\chart.svg' className='img-fluid' alt='chart' />
                  </div>
                </div>
              </div>

              {/* Growth Engines */}
              <div className='tab-pane fade' id='pills-profile' role='tabpanel' aria-labelledby='pills-profile-tab'>
                <div className='ouuuter_Side'>
                  <div className='ouuter__new'>
                    <h2>Growth Engines – 30% ($30M)</h2>
                    <div className='side_div second_div'>
                      {['CRO', 'CHZ', 'HYPE', 'ASTER', 'PUMP'].map(renderCard)}
                    </div>
                  </div>
                  <div>
                    <h2>Exchange Token Basket Allocation</h2>
                    <img src='\assets\charttwo.svg' className='img-fluid' alt='chart' />
                  </div>
                </div>
              </div>

              {/* Moonshots */}
              <div className='tab-pane fade' id='pills-contact' role='tabpanel' aria-labelledby='pills-contact-tab'>
                <div className='ouuuter_Side'>
                  <div className='ouuter__new'>
                    <h2>Moonshots – 30% ($30M)</h2>
                    <div className='bottom_Side'>
                      {['GEMS', 'RAIN'].map(renderCard)}
                    </div>
                  </div>
                  <div>
                    <h2>Exchange Token Basket Allocation</h2>
                    <img src='\assets\chartthree.svg' className='img-fluid' alt='chart' />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Exchange;